module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_patho_phys_banner-a9414854ad090a95b9cff805d7f38940.png";